import { render } from "./BasicExample.vue?vue&type=template&id=0b8eb450"
import script from "./BasicExample.vue?vue&type=script&lang=ts"
export * from "./BasicExample.vue?vue&type=script&lang=ts"
script.render = render

export default script